import {
  DELETE_LEAD_CAPTURE,
  DELETE_LEAD_CAPTURE_SUCCESS,
  DELETE_LEAD_CAPTURE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteLeadCaptureReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_LEAD_CAPTURE:
      return { ...state, loading: true };
    case DELETE_LEAD_CAPTURE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_LEAD_CAPTURE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteLeadCaptureReducer;
